// CAUTION: If you change this value here,
// PLEASE also update the variables `$tile-size` and `$content-columns-3-width` in 'src/style/variables.scss'!
export const STYLE_CONST_3_COLUMNS_REM = '75.5rem'
